<template>
  <div class="bxp_layout-container" style="width: 100%">
   <div>


   </div>
    <v-flex 
      id="bxp_layout_content" 
      class="bxp-layout-content"
      :class="$formFrameworkOptions.wideLayout ? 'bxp-wide-layout' : ''" 
      
      >
      <div class="bxp-form-container">
        <transition name="pop-in" mode="out-in">
          <slot name="content">

          </slot>
        </transition>
      </div>
    </v-flex>
    <v-footer class="bxp-footer">

      <!-- Recaptcha -->
      <bxp-recaptcha />

    </v-footer>
  </div>
</template>

<script>
import BxpRecaptcha from "./BxpRecaptcha";
export default {
  components: {
    BxpRecaptcha
  }
}
</script>


<style>
  .bxp_layout-container {
    display: flex;
    flex-direction: column;
  }

  .bxp-layout-content {
    min-height: 880px;
    padding: 108px 44px 32px;
    margin-right: 0 !important;
    margin-left: 0 !important;
  }

  .bxp-form-container {
    width: 100% !important;
    max-width: 1245px !important;
  }
  .bxp-compact .bxp-form-container {
    /* width: 440px !important; */
    max-width: 100% !important;
  }

  @media (max-width: 1032px) {
    .bxp-layout-content {
      min-height: 100vh;
      height: fit-content;
      padding-top: 94px !important;
      padding-bottom: 12px !important;
    }

    .bxp-layout-content.bxp-wide-layout {
      padding-left: 15px !important;
      padding-right: 15px !important;
    }
  }
</style>
